// extracted by mini-css-extract-plugin
module.exports = {"figura":"Bulbasaur_figura__3bK9S","ajuste":"Bulbasaur_ajuste__1zBK0","link":"Bulbasaur_link__2B6ww"};